var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"collapse-button",class:{ active: _vm.isOpen },attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.caption)+" ")]),(_vm.isOpen)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }